module.exports = __webpack_public_path__ + "static/media/logo.f26bbb24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 18
// module chunks = 0